import React, { Component } from "react";
import { Label, Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { showNotifications } from "../../../../../../actions/notificationActions";
import "./index.css";

class NotificationIcon extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  onClick(e) {
    if (this.props.onClick) {
      this.props.onClick(e);
    }

    const { shouldShowNotificationsCount, count } = this.props;
    this.props.showNotifications({ shouldShowNotificationsCount, count });
  }
  render() {
    //semantic sends event handlers as props
    const { shouldShowNotificationsCount, count } = this.props;
    return (
      <Icon.Group size="large" onClick={this.onClick}>
        <Icon className="white" name={`bell${shouldShowNotificationsCount ? " outline" : ""}`} />
        {shouldShowNotificationsCount ? (
          <Label floating circular color="red" size="mini" className="notifications-count">
            {count}
          </Label>
        ) : null}
      </Icon.Group>
    );
  }
}

const mapStateToProps = state => ({
  shouldShowNotificationsCount: state.notifications.count > 0 && !state.notifications.isAllNotificationsSeen,
  count: state.notifications.count,
});

const mapDispatchToProps = dispatch => ({
  showNotifications: (...props) => dispatch(showNotifications(...props)),
});
export default connect(mapStateToProps, mapDispatchToProps)(NotificationIcon);



// WEBPACK FOOTER //
// ./src/components/Header/Components/NotificationsIndicator/componenets/NotificationIcon/index.js